
import Vue from 'vue';
import { faTimes, faBars } from '@delfi.lt/fa-kit/icons/modules/classic/solid';

export default Vue.extend({
  props: {
    isActive: {
      type: Boolean,
      required: true,
    },
    isEasyChannel: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      faTimes,
      faBars,
    };
  },
});
